module.exports = __webpack_public_path__ + "static/media/Group_1597880740(1).95aea5dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group_1597880740(1).png
// module id = 1210
// module chunks = 0